/**
 * Size types for free text area
 */
export var FreeTextSize;
(function (FreeTextSize) {
    FreeTextSize["Small"] = "small";
    FreeTextSize["Large"] = "large";
})(FreeTextSize || (FreeTextSize = {}));
export function isBeforeAfterImageDescriptor(description) {
    return (description.before !== undefined &&
        description.after !== undefined);
}
//# sourceMappingURL=common.types.js.map